import { render, staticRenderFns } from "./agencyDataForm.vue?vue&type=template&id=50e82480&class=full-heigth&"
import script from "./agencyDataForm.vue?vue&type=script&lang=js&"
export * from "./agencyDataForm.vue?vue&type=script&lang=js&"
import style0 from "./agencyDataForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e82480')) {
      api.createRecord('50e82480', component.options)
    } else {
      api.reload('50e82480', component.options)
    }
    module.hot.accept("./agencyDataForm.vue?vue&type=template&id=50e82480&class=full-heigth&", function () {
      api.rerender('50e82480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/components/agencyDataForm.vue"
export default component.exports